import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeatureGrid from "./components/FeatureGrid";
import AboutSection from "./components/AboutSection";
import BlogSection from "./components/BlogSection";
import CTASection from "./components/CTASection";
import TestimonialSection from "./components/TestimonialSection";
import { usePageSEO } from "@/hooks/usePageSEO";

const SITE_URL = typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL
  ? import.meta.env.VITE_SITE_URL.replace(/\/+$/, '')
  : 'https://superbuyspreadsheet.bar';

export default function Home() {
  usePageSEO({
    title: "Best Superbuy Spreadsheet 2026 | Trusted Links & Guides",
    description: "Discover the best Superbuy Spreadsheet for sneakers, clothing, brands, and trusted sellers. Guides, reviews, safety tips, and buying tutorials for international shoppers.",
    keywords: "Superbuy Spreadsheet, best superbuy spreadsheet, superbuy spreadsheet 2026, superbuy spreadsheet guide, superbuy spreadsheet links, superbuy spreadsheet safe",
    canonicalPath: "/",
    ogType: "website",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Superbuy Spreadsheet",
      "url": SITE_URL,
      "description": "Discover the best Superbuy Spreadsheet for sneakers, clothing, brands, and trusted sellers. Guides, reviews, safety tips, and buying tutorials for international shoppers.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${SITE_URL}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
  });
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoryGrid />
        <FeatureGrid />
        <CTASection />
        <BlogSection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}